import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class CallExpressionCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.CallExpression;
    }
    visitNode(sb, expression, options) {
        sb.emitHelper(expression, options, sb.helpers.callLike);
    }
}

//# sourceMappingURL=CallExpressionCompiler.js.map
